import { useEffect, useMemo } from "react"
import { useNavigate } from "react-router-dom"
import LoaderFullPage from "../../components/Loaders"
import PasswordReset from "./PasswordReset"
import VerifyEmail from "./VerifyEmail"
import { LogError } from "../../helpers/logger"
import { setSessStorage } from "../../helpers/sessionStorage"

export default function Authentication() {
  const navigate = useNavigate()
  const searchParams = useMemo(
    () => new URLSearchParams(window.location.search),
    [],
  )
  const mode = searchParams.get("mode") || ""
  const isSupportedMode = mode === "resetPassword" || mode === "verifyEmail"

  useEffect(() => {
    if (isSupportedMode) return

    const supportedModeLabel = (mode || "missing")
      .replace(/[^a-zA-Z0-9_-]/g, "")
      .slice(0, 40)

    const unsupportedModeMessage = supportedModeLabel
      ? `Authentication action mode "${supportedModeLabel}" is not supported.`
      : "Authentication action mode is not supported."

    LogError("Unsupported authentication action mode", {
      mode,
      hasOobCode: Boolean(searchParams.get("oobCode")),
    })
    setSessStorage("auth_action_error", unsupportedModeMessage)
    navigate("/", { replace: true })
  }, [isSupportedMode, mode, navigate, searchParams])

  if (mode === "resetPassword") {
    return <PasswordReset />
  }

  if (mode === "verifyEmail") {
    return <VerifyEmail />
  }

  return <LoaderFullPage />
}
